import "@/styles/base.scss";
import { ReactNode, StrictMode } from "react";
import ConfigProvider from "@/features/config/context/ConfigProvider.tsx";

type Props = {
  children: ReactNode;
}

const WidgetWrapper = ({ children }: Props) => {
  return (
    <StrictMode>
      <ConfigProvider>
        { children }
      </ConfigProvider>
    </StrictMode>);
}

export default WidgetWrapper;
